import { useRequest, useToggle } from 'ahooks';
import { Button, Form, Input, Modal, message } from 'antd';
import { useAuthorization } from 'components/Authorization';
import { useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { resubmitFeedback } from 'services/api/feedback';

interface ReFeedbackProps {
  caseId: number;
  onFinish: () => void;
}

export const ReFeedback = (props: ReFeedbackProps) => {
  const { caseId, onFinish } = props;
  const { t } = useTranslate();

  const [visible, { toggle: toggleVisible }] = useToggle();
  const [ready, setReady] = useState(false);
  const [form] = Form.useForm<{ desc: string }>();
  const { payload } = useAuthorization<Oversea.Token.Payload>();

  const { loading, runAsync } = useRequest(resubmitFeedback, {
    manual: true,
    onSuccess() {
      message.success(t('feedback_resubmit_msg_success'));
      toggleVisible();
      onFinish();
    },
    onError() {
      message.error(t('translation.操作失败，请稍后再试'));
    },
  });

  return (
    <>
      <Button onClick={toggleVisible}>{t('feedback_btn_not_solve')}</Button>
      <Modal
        zIndex={2000}
        title={t('feedback_btn_not_solve')}
        visible={visible}
        centered
        onCancel={toggleVisible}
        okButtonProps={{
          disabled: !ready,
          loading,
        }}
        onOk={() => {
          form.submit();
        }}
      >
        <Form
          layout="vertical"
          form={form}
          onValuesChange={(_, values) => {
            setReady(!!values.desc);
          }}
          onFinish={(values) => {
            if (payload) {
              runAsync(caseId, {
                userId: payload.id,
                desc: values.desc,
                userName: payload.name,
              });
            }
          }}
        >
          <Form.Item label={t('feedback_resubmit_reason')} name="desc" required>
            <Input.TextArea
              rows={4}
              maxLength={300}
              showCount
              placeholder={t('feedback_resubmit_placeholder')}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
